// extracted by mini-css-extract-plugin
export default {"remaining-shipments":"RemainingShipments_remaining-shipments__hQZRc"};